import { isOutputFeature, isSystemFeature } from './valuePresentation';

const getFeatureName = (feature) => feature?.name ?? feature?.Name ?? '';

export const hasUserSelection = (userSelections, name) => {
  const value = userSelections?.[name];
  if (value === undefined || value === null) return false;
  if (Array.isArray(value)) return value.length > 0;
  return String(value).trim() !== '';
};

export const applyUserSelection = (userSelections, name, value) => {
  const next = { ...(userSelections || {}) };
  const normalized = Array.isArray(value) ? value : String(value ?? '');
  const empty = Array.isArray(normalized) ? normalized.length === 0 : String(normalized).trim() === '';
  if (empty) {
    delete next[name];
  } else {
    next[name] = Array.isArray(normalized) ? normalized : String(normalized);
  }
  return next;
};

export const deriveSystemSelections = (features, userSelections, availableDomains) => {
  const system = {};
  if (!availableDomains) return system;

  (features || []).forEach((feature) => {
    const name = getFeatureName(feature);
    if (!name) return;
    if (isOutputFeature(feature) && !isSystemFeature(feature)) return;
    if (!isSystemFeature(feature) && hasUserSelection(userSelections, name)) return;

    const domain = availableDomains[name];
    if (!Array.isArray(domain) || domain.length !== 1) return;

    const unique = domain[0];
    if (unique === undefined || unique === null || String(unique).trim() === '') return;
    system[name] = String(unique);
  });

  return system;
};

export const displaySelections = (userSelections, systemSelections) => ({
  ...(systemSelections || {}),
  ...(userSelections || {})
});
